module.exports = __webpack_public_path__ + "img/card-plus.svg";